import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import type { TooltipProps } from '@mui/material/Tooltip';
import ChatViewContextTitleRow from 'views/chats/users/header/ChatViewContextTitleRow';
import ViewCountsTooltipContent from './ViewCountsTooltipContent';
import type { ChatFolderColorTier } from 'utils/chat-view-context-title';

/** עיצוב טולטיפ תואם מערכת (כמו ContextualInfoPopover) */
export const chatSidebarNavTooltipSlotProps: TooltipProps['slotProps'] = {
  tooltip: {
    sx: (theme) => ({
      maxWidth: 340,
      py: 1,
      px: 1.25,
      bgcolor: 'background.paper',
      color: 'text.primary',
      border: '1px solid',
      borderColor: 'divider',
      boxShadow: theme.shadows[4],
      fontSize: '0.8125rem',
      lineHeight: 1.5,
      fontWeight: 400,
    }),
  },
  arrow: {
    sx: (theme) => ({
      color: theme.palette.background.paper,
      '&::before': {
        border: '1px solid',
        borderColor: theme.palette.divider,
      },
    }),
  },
};

type ChatSidebarViewNavTooltipContentProps = {
  folderLabel: string;
  viewLabel: string;
  folderTier: ChatFolderColorTier;
  unread: number;
  total: number;
};

export function ChatSidebarViewNavTooltipContent({
  folderLabel,
  viewLabel,
  folderTier,
  unread,
  total,
}: ChatSidebarViewNavTooltipContentProps) {
  return (
    <Box sx={{ minWidth: 168, maxWidth: 320 }}>
      <ChatViewContextTitleRow
        folderLabel={folderLabel}
        viewLabel={viewLabel}
        folderTier={folderTier}
        dense
      />
      <Divider sx={{ my: 0.875, borderColor: 'divider' }} />
      <ViewCountsTooltipContent unread={unread} total={total} />
    </Box>
  );
}

/** טולטיפ כותרת בלבד (ללא מונים) — סרגל מכווץ לפריטים ללא ספירה */
export function ChatSidebarViewNavTooltipTitleOnly({
  folderLabel,
  viewLabel,
  folderTier,
}: Omit<ChatSidebarViewNavTooltipContentProps, 'unread' | 'total'>) {
  return (
    <Stack spacing={0.5} sx={{ minWidth: 140, maxWidth: 320 }}>
      <ChatViewContextTitleRow
        folderLabel={folderLabel}
        viewLabel={viewLabel}
        folderTier={folderTier}
        dense
      />
    </Stack>
  );
}
